export default "__VITE_ASSET__D7Sy8O5Y__"